import React from "react";
import { useQuery } from "@tanstack/react-query";
import { api, LedgerEntry } from "../../lib/api";
import { dateTime, money, titleCase } from "../../lib/format";

export function LedgerTable({ balancePence }: { balancePence?: number }) {
  const { data: ledger } = useQuery<LedgerEntry[]>({ queryKey: ["ledger", "full"], queryFn: () => api.get("/wallet/ledger?limit=200").then((r) => r.data) });
  let running = 0;
  const rows = [...(ledger || [])].reverse().map((e) => { running += e.signed_amount_pence; return { ...e, running }; }).reverse();

  return (
    <div data-testid="ledger-table">
      <div className="eyebrow">Current balance</div>
      <h2 className="mt-2 font-serif text-4xl tabular-nums sm:text-5xl" data-testid="ledger-current-balance">{balancePence === undefined ? "—" : money(balancePence)}</h2>
      <p className="mt-2 text-sm text-neutral-600">Every movement on your account balance, most recent first.</p>
      <div className="mt-6 overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b border-border text-left">
              <th className="eyebrow py-3 font-normal">When</th>
              <th className="eyebrow py-3 font-normal">Type</th>
              <th className="eyebrow py-3 font-normal">Description</th>
              <th className="eyebrow py-3 text-right font-normal">Amount</th>
              <th className="eyebrow py-3 text-right font-normal">Balance</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((e) => (
              <tr key={e.id} className="border-b border-border" data-testid={`ledger-entry-${e.id}`}>
                <td className="py-3 text-neutral-500">{dateTime(e.created_at)}</td>
                <td className="py-3"><span className="border border-border px-2 py-0.5 text-[10px] uppercase tracking-widest">{titleCase(e.kind)}</span></td>
                <td className="py-3">{e.description}{(e as any).pot === "club" && <span className="ml-2 border border-border px-1.5 text-[9px] uppercase tracking-widest text-neutral-500">wine club</span>}<div className="text-xs text-neutral-400">{e.txn_id}</div></td>
                <td className={`py-3 text-right tabular-nums ${e.signed_amount_pence > 0 ? "text-[var(--moss)]" : "text-[var(--ink)]"}`}>{e.signed_amount_pence > 0 ? "+" : ""}{money(e.signed_amount_pence)}</td>
                <td className={`py-3 text-right tabular-nums ${e.running < 0 ? "text-[var(--wine)]" : "text-neutral-500"}`}>{money(e.running)}</td>
              </tr>
            ))}
          </tbody>
        </table>
        {ledger && ledger.length === 0 && <p className="py-6 text-sm text-neutral-500" data-testid="ledger-table-empty">No entries yet.</p>}
      </div>
    </div>
  );
}
